<template>
    <div class="imagebg" :style="getBackground()">
            <img
                src="../assets/images/logo2.png"
                loading="lazy"
                class="center"
                style="width:100px;hight:100px;"
            >
    </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/database';
import router from "./../router";
import liffService from "@/services/liff";
export default {
  name: 'SplashScreen',
  created() {
    // LIFF is already initialized by router guard
    this.loadUserData();
  },
  data() {
    return {
      defaultOptions: null,
    }
  },
  methods: {
    getBackground(){
      const rand = Math.floor(Math.random() * 10) + 1;
      return `background-image: url("${require('../assets/images/instagramestory'+rand+'.jpg')}");`;
      //return `background-image: url("${require('../assets/images/valentine/'+rand+'.jpg')}");`;
      // const rand = Math.floor(Math.random() * 7) + 1;
      // return `background-image: url("${require('../assets/images/halloween'+rand+'.jpg')}");`;
    },
    async loadUserData() {
      // Get profile from centralized service (already fetched by router guard)
      const profile = liffService.profile;
      if (!profile) return;

      this.userId = profile.userId || "";
      this.pictureUrl = profile.pictureUrl || "none";
      if (this.userId) {
        const users = (
          await firebase
            .database()
            .ref(`/users`)
            .orderByChild("userId")
            .equalTo(this.userId)
            .once("value")
        ).val();
        if (!users) {
          const queryString = decodeURIComponent(window.location.search);
          const params = new URLSearchParams(queryString);
          const master = params.get("uid") ? params.get("uid") : 28;
          const u = params.get("u") ? params.get("u") : '';
          if(u){
            //share friends
            router.replace("/registertest/"+u);
          }else if(master == 41 || master == 44 || master == 45)
            router.replace("/registerk/"+master);
          else if(master == 48)
            router.replace("/registerj/"+master);
          else
            router.replace("/register/"+master);
        } else {
          let user = {};
          for (const x in users) {
            user = users[x];
          }
          router.replace("/login");
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  /*padding-top: 20%;*/
  padding-top:35px;
}
.imagebg {
  content: "";
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-image: url("../assets/images/instagramestory2.jpg");
  background-position: center center; 
  background-attachment: fixed; 
  background-repeat: no-repeat; 
  background-size: cover; 
}
</style>